import PropTypes from 'prop-types';
import React from 'react';

import UnicodeCharacterChooser from 'notebook/mediocre/symbols/UnicodeCharacterChooser';
import Modal from 'ui-library/modals/Modal';

import isCharBlocked from './isCharBlocked';

interface InsertSymbolModalProps {
  onRequestClose: () => void;
  onRequestSubmit: (symbol: string) => void;
}

interface State {
  symbol: string | null;
}

class InsertSymbolModal extends React.PureComponent<InsertSymbolModalProps, State> {
  static propTypes = {
    onRequestClose: PropTypes.func.isRequired,
    onRequestSubmit: PropTypes.func.isRequired,
  };

  override state: State = {
    symbol: null,
  };

  onRequestSubmit = (): void => {
    if (this.state.symbol == null) {
      // If there's no symbol, don't submit the modal. The footer button should be disabled, but there are
      // various ways to submit the form (in Safari, pressing enter on the text field submits the form, even
      // if the submit button is disabled).
      return;
    }
    this.insertSymbol(this.state.symbol);
  };

  insertSymbol(symbol: string): void {
    this.props.onRequestSubmit(symbol);
    this.props.onRequestClose();
  }

  selectSymbol = ({char, insert}: {char: string; insert: boolean}): void => {
    if (isCharBlocked(char)) {
      return;
    }
    if (insert) {
      this.insertSymbol(char);
    } else {
      this.setState({symbol: char});
    }
  };

  override render(): JSX.Element {
    return (
      <Modal
        title="Insert symbol"
        onRequestClose={this.props.onRequestClose}
        onRequestSubmit={this.onRequestSubmit}
        buttons={[{text: 'Insert', submit: true, disabled: this.state.symbol == null}]}
      >
        <UnicodeCharacterChooser char={this.state.symbol} selectChar={this.selectSymbol} />
      </Modal>
    );
  }
}

export default InsertSymbolModal;
